import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Container, PageTitle, NbCard, Chip, NbButton } from "@/components/nb";
import { Stagger, Item } from "@/components/motion";
import { Trash2, Share2, Play } from "lucide-react";
import { toast } from "sonner";

export default function Bookmarks() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = () => api.get("/study/diagnostic/bookmarks").then((r) => setItems(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const del = async (id) => {
    await api.delete(`/study/diagnostic/bookmarks/${id}`);
    load();
  };
  const share = async (id) => {
    const url = `${window.location.origin}/study/bookmark/${id}`;
    try { await navigator.clipboard.writeText(url); toast.success("Share link copied!"); }
    catch { toast.success(`Share link: ${url}`); }
  };

  return (
    <Container>
      <PageTitle eyebrow="SAVED TESTS" title="Your AI-crafted diagnostics." sub="Retake, share, or delete." />

      {loading && <NbCard>Loading...</NbCard>}
      {!loading && items.length === 0 && (
        <NbCard color="tertiary" className="!p-8" data-testid="empty-bookmarks">
          <div className="font-heading font-black text-2xl tracking-tight">No saved tests yet.</div>
          <p className="text-neutral-800 mt-2">Generate an AI test and hit the bookmark button.</p>
          <div className="mt-4"><Link to="/study/diagnostic"><NbButton color="black">Create one →</NbButton></Link></div>
        </NbCard>
      )}

      <Stagger className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="bookmarks-list">
        {items.map((b) => (
          <Item key={b.id}>
            <NbCard className="!p-5 h-full flex flex-col gap-3">
              <div className="flex items-center justify-between">
                <Chip color="accent">{(b.difficulty || "medium").toUpperCase()}</Chip>
                <span className="font-mono-sl text-[10px] uppercase text-neutral-500">{new Date(b.created_at).toLocaleDateString()}</span>
              </div>
              <h3 className="font-heading font-black text-2xl tracking-tight">{b.title}</h3>
              <p className="font-mono-sl text-xs uppercase text-neutral-600">{b.questions.length} questions</p>
              <div className="flex gap-2 mt-auto flex-wrap">
                <NbButton onClick={() => nav(`/study/bookmark/${b.id}`)} color="primary" data-testid={`take-${b.id}`}><Play className="w-4 h-4 inline-block mr-1" /> Take</NbButton>
                <NbButton onClick={() => share(b.id)} color="white" data-testid={`share-${b.id}`}><Share2 className="w-4 h-4 inline-block mr-1" /> Share</NbButton>
                <NbButton onClick={() => del(b.id)} color="white" data-testid={`del-${b.id}`}><Trash2 className="w-4 h-4" /></NbButton>
              </div>
            </NbCard>
          </Item>
        ))}
      </Stagger>
    </Container>
  );
}
